var map = {
	"./_default.demo.json": 761,
	"./_default.json": 762,
	"./address/provinces-ita.json": 298,
	"./ancot.ancot.json": 763,
	"./ancot.demo.json": 764,
	"./ancot.json": 765,
	"./bedifferent.json": 766,
	"./bedifferent.wikimuseo.prod.json": 767,
	"./bmeglobal.json": 768,
	"./bmeselfservice.dev.json": 769,
	"./bmeselfservice.json": 770,
	"./bmesuper.json": 771,
	"./business/csp.json": 408,
	"./business/ekom.json": 409,
	"./business/liberacta.json": 410,
	"./business/self-service.json": 411,
	"./cittaviva.json": 772,
	"./class.json": 773,
	"./class.prod.json": 774,
	"./class.staging.json": 775,
	"./crai.json": 776,
	"./csp.csp.json": 777,
	"./csp.json": 778,
	"./csp.test.json": 779,
	"./demo.json": 780,
	"./democrm.json": 781,
	"./demoloop.dev.json": 782,
	"./demoloop.json": 783,
	"./demoretail.json": 784,
	"./demoretaildev.json": 785,
	"./doro.json": 786,
	"./ekom.ekom.json": 787,
	"./ekom.json": 788,
	"./enel.json": 789,
	"./fashionzclub.json": 790,
	"./firebase/ancot-x-bme.json": 412,
	"./firebase/bedifferent-3b69e.json": 413,
	"./firebase/bmarken-c034c.json": 414,
	"./firebase/bmarken-merchant.json": 415,
	"./firebase/bmarken-pro.json": 416,
	"./firebase/bme-global-test.json": 417,
	"./firebase/bme-merchant-test.json": 418,
	"./firebase/bme-super-test.json": 419,
	"./firebase/campus-x-bme.json": 420,
	"./firebase/chiusi-x-bme.json": 421,
	"./firebase/csp-x-bme.json": 422,
	"./firebase/ekom-x-bme.json": 423,
	"./firebase/gdsp-x-bme-merchant.json": 424,
	"./firebase/gdsp-x-bme.json": 425,
	"./firebase/go12-bmarken-api.json": 426,
	"./firebase/lcng-x-bme.json": 427,
	"./firebase/lie-x-bme.json": 428,
	"./firebase/mauto-x-bme.json": 429,
	"./firebase/rtx-x-bme.json": 430,
	"./firebase/stazzema-d7a92.json": 431,
	"./gdsp.json": 791,
	"./gdsp.prod.json": 792,
	"./gdsp.staging.json": 793,
	"./goovi.json": 794,
	"./lcng.json": 795,
	"./lcng.lcng.json": 796,
	"./lcng.test.json": 797,
	"./lie.json": 798,
	"./lie.wikimuseo.prod.json": 799,
	"./manifest/ancot.json": 432,
	"./manifest/bmarken.json": 433,
	"./manifest/class.json": 434,
	"./manifest/csp.json": 435,
	"./manifest/ekom.json": 436,
	"./manifest/gdsp.json": 437,
	"./manifest/lcng.json": 438,
	"./manifest/lie.json": 439,
	"./manifest/mauto.json": 440,
	"./manifest/mysarca.json": 441,
	"./manifest/wikimuseo.json": 442,
	"./mauto.json": 800,
	"./mauto.wikimuseo.prod.json": 801,
	"./museochiusi.json": 802,
	"./mysarca.bmarken-fe.staging.json": 803,
	"./mysarca.json": 804,
	"./mysarca.mysarca.json": 805,
	"./mysarca.production.json": 806,
	"./mysarca.staging.json": 807,
	"./mysarcadevprod.json": 808,
	"./mysarcadevproddev.json": 809,
	"./mysarcadevstaging.json": 810,
	"./mysarcadevstaginglocal.json": 811,
	"./retail.json": 812,
	"./retaildev.json": 813,
	"./retex-bistrot.json": 814,
	"./retex.json": 815,
	"./self-service-apps.apps.json": 816,
	"./self-service-apps.json": 817,
	"./self-service.json": 818,
	"./self-service.self.json": 819,
	"./self-service.staging.json": 820,
	"./smarttouch.json": 821,
	"./smkt.json": 822,
	"./stazzema.json": 823,
	"./stazzema.wikimuseo.prod.json": 824,
	"./test.json": 825,
	"./test.test.json": 826,
	"./themes/_default.json": 443,
	"./themes/ancot.json": 444,
	"./themes/bmarken.json": 445,
	"./themes/cittaviva.json": 446,
	"./themes/class.json": 447,
	"./themes/coop.json": 448,
	"./themes/crai.json": 449,
	"./themes/csp.json": 450,
	"./themes/doreca.json": 451,
	"./themes/doro.json": 452,
	"./themes/ekom.json": 453,
	"./themes/enel.json": 454,
	"./themes/fashionzclub.json": 455,
	"./themes/gdsp.json": 456,
	"./themes/goovi.json": 457,
	"./themes/lcng.json": 458,
	"./themes/lie.json": 459,
	"./themes/mauto.json": 460,
	"./themes/mysarca.json": 461,
	"./themes/retail.json": 462,
	"./themes/retex-bistrot.json": 463,
	"./themes/retex.json": 464,
	"./themes/self-service.json": 465,
	"./themes/smarttouch.json": 466,
	"./themes/smkt.json": 467,
	"./themes/voghera.json": 468,
	"./themes/wikimuseo.json": 469,
	"./voghera.json": 827,
	"./wikimuseo.json": 828,
	"./wikimuseo.wikimuseo.prod.json": 829,
	"./wikimuseo.wikimuseo.test.json": 830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 760;